/**
 * The video-list part of a campaign save. An existing campaign also sends the
 * list the page loaded, so the backend applies only this admin's additions and
 * removals: a live the automatic-lives routine linked after the page loaded is
 * not dropped by a stale save.
 */
export function downloadIdsInput({
  current,
  loaded,
}: {
  current: string[];
  loaded: string[] | null;
}): { youtube_download_ids: string[]; youtube_download_ids_base?: string[] } {
  if (!loaded) return { youtube_download_ids: current };
  return { youtube_download_ids: current, youtube_download_ids_base: loaded };
}
